import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { "aria-label": "Footer Navigation" }
const _hoisted_4 = { class: "links" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: _ctx.content.legal.imprintSrc,
              target: "_blank",
              rel: "noopener"
            }, "Impressum", 8, _hoisted_5)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: _ctx.content.legal.privacySrc,
              target: "_blank",
              rel: "noopener"
            }, "Datenschutz", 8, _hoisted_6)
          ]),
          (_ctx.content.legal.wcagSrc && _ctx.content.legal.wcagSrc !== '')
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("a", {
                  href: _ctx.content.legal.wcagSrc,
                  target: "_blank",
                  rel: "noopener"
                }, _toDisplayString(_ctx.content.legal.wcagText), 9, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadWindowPrivacyManagerModal())),
              type: "button",
              class: "link"
            }, " Datenschutz-Einstellungen ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.content.legal.copyright), 1)
    ])
  ]))
}